type LogoKind = 'small' | 'full';

const withProtocol = (value: string): string => {
	if (!value) {
		return '';
	}

	if (/^https?:\/\//i.test(value)) {
		return value;
	}

	if (value.startsWith('//')) {
		return `https:${value}`;
	}

	if (value.startsWith('www.')) {
		return `https://${value}`;
	}

	if (value.startsWith('/')) {
		return value;
	}

	// Handle host/path values like "api.matflixx.de/logo/full_logo.png".
	return `https://${value}`;
};

const sanitizeRawUrl = (rawUrl: string): string => {
	const trimmed = rawUrl.trim();
	if (!trimmed) {
		return '';
	}

	const fixedProtocol = trimmed.replace(/^ttps:\/\//i, 'https://').replace(/^http:\/\//i, 'https://');
	return withProtocol(fixedProtocol);
};

const getImageHost = (): string => {
	const envHost = process.env.REACT_APP_IMAGE_LINK || '';
	const normalized = sanitizeRawUrl(envHost).replace(/\/+$/, '');
	return normalized;
};

export const getDefaultLogoUrl = (kind: LogoKind): string => {
	const imageHost = getImageHost();
	const fileName = kind === 'small' ? 'small_logo.jpg' : 'full_logo.png';
	return imageHost ? `${imageHost}/logo/${fileName}` : `/logo/${fileName}`;
};

export const resolveLogoUrl = (rawUrl: string | null | undefined, kind: LogoKind): string => {
	const normalized = sanitizeRawUrl(rawUrl || '');
	if (!normalized) {
		return getDefaultLogoUrl(kind);
	}

	if (normalized.startsWith('/')) {
		const imageHost = getImageHost();
		return imageHost ? `${imageHost}${normalized}` : normalized;
	}

	return normalized;
};
